import styled from 'styled-components';
import { Typography } from 'components/generic/typography';
import { verticalEllipsis } from 'modules/helpers/mixins';

const Brand = styled(Typography.Label)<{ maxVerticalLines?: number }>`
    ${({ maxVerticalLines }) => verticalEllipsis(maxVerticalLines || 1)}
    ${({ theme }) => (theme as any).BrandTitle}
`;

const Product = styled(Typography.Body)<{ maxVerticalLines?: number }>`
    ${({ maxVerticalLines }) => verticalEllipsis(maxVerticalLines || 2)}
    color: ${({ theme }) => theme.ColorTextPrimary};
    ${({ theme }) => (theme as any).ProductTitle}
`;

const Variant = styled(Typography.Body)<{ maxVerticalLines?: number }>`
    ${({ maxVerticalLines }) => verticalEllipsis(maxVerticalLines || 2)}
    color: ${({ theme }) => theme.ColorTextPrimary};
    ${({ theme }) => (theme as any).VariantTitle}
`;

const Ellipsis = styled.span`
    flex-shrink: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

const MoreVariants = styled.span`
    flex-shrink: 0;
    white-space: nowrap;
`;

const Miscellaneous = styled(Typography.Body)<{ maxVerticalLines?: number }>`
    ${({ maxVerticalLines }) => verticalEllipsis(maxVerticalLines || 2)}
    ${({ theme }) => (theme as any).ProductMiscellaneousTitle}
`;

const Snippet = styled(Typography.Body)<{ maxVerticalLines?: number }>`
    ${({ maxVerticalLines }) => verticalEllipsis(maxVerticalLines || 2)}
    color: ${({ theme }) => theme.ColorTextPrimary};
    ${({ theme }) => (theme as any).ProductSnippet}
`;

export { Brand, Product, Variant, Ellipsis, MoreVariants, Miscellaneous, Snippet };
